module.exports = __webpack_public_path__ + "static/media/game-fail.ca5a4c5b.svg";